import React from 'react';
import { Button, Modal, Row, Col } from 'react-bootstrap';
import classes from './../TrialstatNoto.module.css';

const ReadCompleteModal = (props) => {
    const handleClose = () => {
        props.setReadCompleteData({ show: false });
    }

    const SaveReadComplete = (event) => {
        let model =
        {
            TaskID: props.readCompleteData.taskId,
        }

        fetch('api/ReadsAssigned/SaveReadComplete', {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(model)
        }).then(r => r.json()).then(res => {
            if (res == 0) {
                alert('Read complete not updated, something went wrong.');
                return false;
            }
            if (res > 0) {
                props.fetchReadsAssigned();
                props.setReadCompleteData({ show: false });
            }
        })
        return true;
    };

    return (
        <>
            <Modal centered
                show={props.readCompleteData.show}
                onHide={handleClose}
                dialogClassName={classes.TSModalDailog_Eight} backdrop="static">
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-1" style={{ width: "4%" }}>
                        </div>
                        <div className="col-sm-10" style={{ width: "95%" }}>
                            <div className="row">
                                <div className="row mt-3">
                                    <div className="col-sm-4">
                                        <label className="mb-1"><b> Procedure ID : </b></label>
                                    </div>
                                    <div className="col-sm-8">
                                        <label className="mb-1">{props.readCompleteData.procedureId}</label>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-sm-4">
                                        <label className="mb-1"><b> Study Name : </b></label>
                                    </div>
                                    <div className="col-sm-8">
                                        <label className="mb-1">{props.readCompleteData.studyName}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-1" style={{ width: "4%" }}>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button className="btn btn-md btn-success" variant="primary" onClick={SaveReadComplete}>
                        Read Completed
                        </Button>
                    <Button className="btn btn-md btn-danger" variant="secondary" onClick={handleClose}>
                        Read Not Completed
                        </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default ReadCompleteModal;